import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>{`Página não encontrada · ${BRAND.name}`}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="max-w-3xl mx-auto px-5 py-24 text-center">
        <div className="text-[11px] uppercase tracking-[0.25em] text-[#D4A652] mb-3 font-semibold">404</div>
        <h1 className="font-public-title text-4xl text-stone-900 mb-4">Página não encontrada</h1>
        <p className="text-stone-600 mb-8 max-w-lg mx-auto">
          O endereço buscado pode ter sido alterado ou removido. Volte para explorar nossas pousadas.
        </p>
        <Link
          to="/"
          data-testid="notfound-back"
          className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-[#083A6B] hover:bg-[#052B50] text-white text-sm font-medium"
        >
          <ArrowLeft size={14} /> Voltar para o início
        </Link>
      </div>
    </>
  );
}
